jQuery(document).ready(function ($) {
    $('.oab-faq-block__question-icon, .oab-faq-block__question').on('click', function () {
        let parentContainer = $(this).closest('.oab-faq-block__container');

        parentContainer.find('.oab-faq-block__question-icon').toggleClass('active');
        parentContainer.find('.oab-faq-block__question').toggleClass('active');
        parentContainer.find('.oab-faq-block__answer-container').slideToggle();

        let plusIcon = parentContainer.find('.oab-faq-block__plus-icon');
        let minusIcon = parentContainer.find('.oab-faq-block__minus-icon');

        if(plusIcon.hasClass('active')) {
            plusIcon.removeClass('active')
        } else {
            plusIcon.addClass('active')
        }
        if(minusIcon.hasClass('active')) {
            minusIcon.removeClass('active')
        } else {
            minusIcon.addClass('active')
        }
    })
});

